import { render, staticRenderFns } from "./small-detail.vue?vue&type=template&id=a2ca6bda&scoped=true&"
import script from "./small-detail.vue?vue&type=script&lang=js&"
export * from "./small-detail.vue?vue&type=script&lang=js&"
import style0 from "./small-detail.vue?vue&type=style&index=0&id=a2ca6bda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2ca6bda",
  null
  
)

export default component.exports